export enum ANIMATION_CONTROL_SUBJECT {
  TABLE_BOOKING = 'tableBookingSubject',
}
